import useMutation from "src/hooks/useMutation";

function useEmployeeUpdate(id) {
  return useMutation({
    path: `/api/v1/users/${id}`,
    method: "PUT",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/users`,
      shouldRevalidate: true,
    },
  });
}

export default useEmployeeUpdate;
